import dayjs from 'dayjs';

export const formatDate = (date: Date) => dayjs(date).format('ddd DD/MM');
